import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../../generic-components/Heading';
import { convertValueToUSD } from '../../../../helpers/currency.helper';
import Button from '../../../../generic-components/Button';
import { FlowContext } from '../../context';
import { STEPS, STYLES } from '../../consts';
import { ISavingsBucket } from '../../interfaces';
import { ReactComponent as InfoIcon } from '../../../../assets/svg/info-icon.svg';
import { LiliToolTip } from '../../../../generic-components/LiliToolTip';
import { APY } from '../../../../constants/general';

const ACTION_TYPES = {
  ADD: 'add',
  WITHDRAW: 'withdraw',
};

const MONEY_MOVEMENT_TYPES = {
  ADD: false,
  WITHDRAW: true,
};

interface IProps {
  bucketState: ISavingsBucket;
}

export const BalanceController = ({ bucketState }: IProps) => {
  const context = useContext(FlowContext);
  const { t } = useTranslation();

  const isWithdrawAvailable = useMemo(() => !!bucketState?.balance, [bucketState]);

  const getBalanceToShow = () => {
    const balance = bucketState?.balance || 0;
    return convertValueToUSD(balance, 2);
  };

  function handleAction(actionType: string) {
    switch (actionType) {
      case ACTION_TYPES.ADD:
        context?.changeMoneyMovementMode(MONEY_MOVEMENT_TYPES.ADD);
        context?.changeActiveStep(STEPS.MONEY_MOVEMENT);
        break;

      case ACTION_TYPES.WITHDRAW:
        context?.changeMoneyMovementMode(MONEY_MOVEMENT_TYPES.WITHDRAW);
        context?.changeActiveStep(STEPS.MONEY_MOVEMENT);
        break;

      default:
        console.error('');
    }
  }

  return (
    <div className='w-full h-full flex flex-col items-center justify-center'>
      <Heading title={getBalanceToShow()} className=' font-metricR text-[32px] text-bw08' />

      <div className='flex items-center mb-[21px] gap-[4px]'>
        <Heading title={`${context.isSavingsBucket ? t('EMERGENCY_BUCKET_HEADER_PRO') : t('EMERGENCY_BUCKET_HEADER_BASIC')} ${t('SAVINGS_BUCKET.BALANCE_CONTROLLER.BALANCE')}`} className='font-metricR text-[14px] text-bw07' />
        {context.isSavingsBucket && (
        <LiliToolTip
          tooltipClassName='relative w-fit'
          childrenClassName={STYLES.BALANCE_CONTROLLER.TT}
          toolTipChildren={<Heading title={`${t('SAVINGS_BUCKET.BALANCE_CONTROLLER.APY_PART_A')} ${APY} ${t('SAVINGS_BUCKET.BALANCE_CONTROLLER.APY_PART_B')}`} className='font-metricR text-[16px] text-bw07' />}
        >
          <InfoIcon className='cursor-pointer' />
        </LiliToolTip>
        )}
      </div>

      <div className='flex items-center w-full px-[24px] gap-[22px]'>
        <Button onClick={() => handleAction(ACTION_TYPES.ADD)} className='w-full bg-action01 hover:shadow-light py-[10px] rounded-[4px] text-action03 font-metricRMedium text-[14px]' title={t('SAVINGS_BUCKET.BALANCE_CONTROLLER.CTA_ADD')} id='actionAdd' />
        {isWithdrawAvailable && <Button onClick={() => handleAction(ACTION_TYPES.WITHDRAW)} className='w-full bg-action01 hover:shadow-light py-[10px] rounded-[4px] text-action03 font-metricRMedium text-[14px]' title={t('SAVINGS_BUCKET.BALANCE_CONTROLLER.CTA_WITHDRAW')} id='actionWithdraw' />}
      </div>
    </div>
  );
};
